import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  type: "",
  data: {
    label: "",
    basic_details: {
      stage_name: "",
      email_notification: false,
      is_initial_stage: true,
    },
    dependency: [],
    primary_actions: [],
    secondary_actions: [],
    sla: [],
    open_modal: false
  },
};

const workflowData_slice = createSlice({
  name: "workflowData",
  initialState,
  reducers: {
    set_label: (state, action) => {
      state.data.label = action.payload;
    },
    set_basic_details: (state, action) => {
      state.data.basic_details = action.payload;
    },
    set_id: (state, action) => {
      state.id = action.payload;
    },
    set_dependency: (state, action) => {
      state.data.dependency = action.payload;
    },
    set_primary_actions: (state, action) => {
      state.data.primary_actions = action.payload;
    },
    set_secondary_actions: (state, action) => {
      state.data.secondary_actions = action.payload;
    },
    set_sla: (state, action) => {
      state.data.sla = action.payload;
    },
    set_current_node: (state, action) => {
      return action.payload;
    },
    set_open_modal: (state) => {
      state.data.open_modal = !state.data.open_modal 
    },
    reset_workflow_data: () => initialState, 
  },
});

export default workflowData_slice.reducer;

export const {
  set_basic_details,
  set_id,
  set_dependency,
  set_primary_actions,
  set_secondary_actions,
  set_sla,
  set_current_node,
  set_label,
  reset_workflow_data,
  set_open_modal
} = workflowData_slice.actions;
